import React, { useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';

import { AppProvider, Page, Frame, DataTable, Card, Link, Heading, Tabs, Loading } from '@shopify/polaris';
import { ViewMajorMonotone } from '@shopify/polaris-icons';

import debounce from 'lodash/debounce';
import AutocompleteSearch from "@presentational/AutocompleteSearch";
import ReturnsByOrder from '@presentational/goods_moved_log/ReturnsByOrder'
import ReturnsByTransfer from '@presentational/goods_moved_log/ReturnsByTransfer'

import TransactionsHistory from '@container/sale_report/components/SaleReportTransactionsHistory';

import axios from '@utils/axios';

const propTypes = {
  sellerUsers: PropTypes.array,
  isAdmin: PropTypes.bool.isRequired,
  userId: PropTypes.number, // null for admin

  transferURLBase: PropTypes.string.isRequired,
  filterURL: PropTypes.string.isRequired,
  brightpearlOrderURL: PropTypes.string,
  date: PropTypes.string.isRequired, // iso8601
  breadcrumbs: PropTypes.array.isRequired,
}

const defaultProps = {

}

// TODO when filtering by user, make filter locally instead of fetching from API again!
const GoodsMovedLogsLookup = (props) => {
  const [loading, setLoading] = useState(false);
  const [userId, setUserId] = useState(props.userId);
  const [reportData, setReportData] = useState([]);

  // Auto execute query for first load
  useEffect( () => {
    submitFilter(null);
  }, [])

  const submitFilter = async (selectedUserId) => {
    try {
      setLoading(true);
      setReportData([]);
      const response = await axios.post(props.filterURL, { user_id: selectedUserId } );
      const { data } = response;
      if(data){
        console.log("D",data);
        setReportData(data.data);
      }
    } catch (error) {
      console.log(error);
      alert("Ocurrio un error de conexión.")
    }
    setLoading(false);
  }

  // const debouncedFilter = useCallback( debounce(submitFilter, 400), [] );

  const clearUserSearch = () => {
    setUserId(null);
  }

  const handleUserChange = (selectedValue) => {
    setUserId(selectedValue);
    submitFilter(selectedValue)
  }

  let secondaryActions = [];
  if(props.brightpearlOrderURL){
    secondaryActions = [{
        content: 'Ver SO en Brightpearl',
        external: true,
        url: props.brightpearlOrderURL,
        icon: ViewMajorMonotone,
    }];
  }

  return (
    <AppProvider>
      <Frame>
        <Page fullWidth 
          title="Salida Inventario APU" 
          subtitle={ I18n.l("time.formats.long", props.date) }
          breadcrumbs={ props.breadcrumbs }
          secondaryActions={secondaryActions}
        >
          { loading && <Loading /> }

            { reportData[0] &&
              <Card>
                <Card.Header title="Resumen">
                  { props.sellerUsers &&
                    <AutocompleteSearch
                      placeholder = "Seleccionar Seller..."
                      filterOptions = { props.sellerUsers }
                      onClearCallback={ clearUserSearch }
                      searchDelay={ 100 }
                      onSelectionCallback={ (selectedOptions) => handleUserChange(selectedOptions[0]) }
                    />
                  }
                </Card.Header>

                <TransactionsHistory
                  isSeller={ !props.isAdmin }
                  transferURLBase={ props.transferURLBase }
                  transactions={ reportData[0].transaction_history }
                  transactionTotalsMoney={ [reportData[0].full_amount_money] }
                  displayOriginTransfer
                />
              </Card>
            }

            {/* Empty state */}
            { !loading && reportData.length == 0 && !!userId &&
              <Card.Section>
                <Heading>No se encontraron resultados...</Heading>
              </Card.Section>
            }
        </Page>
      </Frame>
    </AppProvider>
  )
};

GoodsMovedLogsLookup.propTypes = propTypes;
GoodsMovedLogsLookup.defaultProps = defaultProps;

export default GoodsMovedLogsLookup;